import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  container: {
    margin: '30px 0',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      margin: '30px 0 0 0',
    },
  },
  title: {
    margin: '30px 0',
  },
  btn: {
    padding: '0 40px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      borderRadius: '0',
      padding: '20px 0',
    },
  },
});
